export const CREW_DASHBOARD_STORE_ID = 'CrewDashboardStore';
